import React from 'react'
import { Typography, Grid, Container, styled, Paper } from '@mui/material'
import PropTypes from 'prop-types'
import MobileMenu from './mobilemenu.component'
const PREFIX = 'Layout'

const classes = {
  gridContainer: `${PREFIX}-grid-container`,
  mobileStepLabel: `${PREFIX}-mobile-step-label`,
  stepLabel: `${PREFIX}-step-label`,
  noMarginBottom: `${PREFIX}-margin-bottom`,
  title: `${PREFIX}-step-title`,
  image: `${PREFIX}-image`,
  noPadding: `${PREFIX}-no-padding`,
  addPaddingIfRightImage: `${PREFIX}-add-padding-if-right-image`,
  greyColor: `${PREFIX}-grey-color`,
  subTitle: `${PREFIX}-step-sub-title`,
}

const styles = ({ theme }) => ({
  [`& .${classes.gridContainer}`]: {
    padding: theme.spacing(2, 2),
    margin: theme.spacing(2, 0),
    borderRadius: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      margin: theme.spacing(4, 0),
      padding: theme.spacing(4, 8),
    },
    [theme.breakpoints.up('md')]: {
      margin: theme.spacing(8, 0),
      padding: theme.spacing(4, 6),
    },
    [theme.breakpoints.up('lg')]: {
      margin: theme.spacing(10, 0),
      padding: theme.spacing(6, 14),
    },
  },
  [`& .${classes.title}`]: {
    marginBottom: theme.spacing(1),
    fontWeight: 700,
  },
  [`& .${classes.greyColor}`]: {
    color: theme.palette.grey[500],
  },
  [`& .${classes.subTitle}`]: {
    marginBottom: theme.spacing(3.5),
  },
})

const StyledContainer = styled(Container)(styles)

function Layout({ step, content, showMobileMenu = false, skipTitle = false }) {
  return (
    <>
      {showMobileMenu && <MobileMenu />}

      <StyledContainer>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <Grid
            item
            xs={12}
            sm={8}
            md={10}
            lg={12}
            component={Paper}
            elevation={3}
            className={classes.gridContainer}
          >
            {!skipTitle && (
              <>
                <Typography
                  className={[classes.title, classes.greyColor].join(' ')}
                  variant="h5"
                >
                  {step && step.title}
                </Typography>
                <Typography variant="h3" className={classes.subTitle}>
                  {step && step.subTitle}
                </Typography>
              </>
            )}

            {content}
          </Grid>
        </Grid>
      </StyledContainer>
    </>
  )
}

Layout.propTypes = {
  step: PropTypes.object,
  content: PropTypes.element,
  showMobileMenu: PropTypes.bool,
  skipTitle: PropTypes.bool,
}

export default Layout
